import styled from 'styled-components';
import { colorsV2 } from '../../../../../colors-v2';

export const ContentItemGroupSubLayout = styled.ol`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding-left: 20px;
  margin-left: 2px;
  margin-bottom: 12px;
  box-shadow: 1px 0 0 0 #d8d9dc inset;
  color: ${colorsV2.black70};
  margin-top: 12px;
  gap: 8px;
`;
